import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import { SearchFacet } from '#server/models';
import { featureConfig } from '@/env-exports';
import { useSearchContext } from '@/context';
import { SearchTab, SearchTabProps } from './SearchTab';

//TODO: Make this come from cms/config
const initialTabs: SearchTabProps[] = [
  { index: 0, to: '#', label: 'All', value: 'all' },
  { index: 1, to: '#', label: 'Courses', value: 'courses' },
  { index: 2, to: '#', label: 'People', value: 'people' },
  { index: 3, to: '#', label: 'Events', value: 'events' },
  { index: 4, to: '#', label: 'News', value: 'news' },
  ...(featureConfig.researchFacetEnabled ? [{ index: 5, to: '#', label: 'Research', value: 'research' }] : ([] as any)),
];

export interface SearchtabsProps {
  handleTabClick: (value: SearchFacet) => void;
  isResultsPageMode?: boolean;
  className?: string;
  ref?: React.Ref<HTMLDivElement>;
}

export function SearchTabs({ ref, ...props }: SearchtabsProps) {
  const { facet, searchResults } = useSearchContext();
  const tabs = initialTabs.map((tab) => ({ ...tab, isSelected: tab.value === facet })).sort((a, b) => a.index - b.index);

  return (
    <div
      ref={ref}
      className={twMerge(
        'px-10[&_>_button]:h-10 max-w-screen z-20 w-full lg:z-0',
        props.isResultsPageMode
          ? 'sticky top-[124px] flex-nowrap justify-center lg:relative lg:-top-[9px] lg:mx-auto lg:max-w-screen-md'
          : 'flex-wrap justify-start',
        props.className,
      )}
    >
      <div
        className={twMerge(
          'w-full drop-shadow-sm',
          props.isResultsPageMode
            ? 'absolute -top-[60px] overflow-x-auto bg-deep-blue-50 px-4 pt-2 lg:drop-shadow-none'
            : '',
        )}
      >
        <div
          className={twMerge(
            'flex w-full flex-row gap-[10px]',
            props.isResultsPageMode ? 'min-w-fit justify-center' : 'flex-wrap',
          )}
        >
          {tabs
            .filter((tab) => !tab.hidden)
            .map((tab) => (
              <SearchTab
                key={tab.index}
                index={tab.index}
                to={tab.to}
                label={tab.label}
                isSelected={tab.isSelected}
                isResultsPageMode={props.isResultsPageMode}
                value={tab.value}
                facetCount={searchResults?.facetResultCounts[tab.value]}
                onClick={() => props.handleTabClick(tab.value)}
                hidden={tab.hidden}
              />
            ))}
        </div>
      </div>
    </div>
  );
}
